import { Component, OnInit } from '@angular/core';
import { ApiService } from '@app/gateway/services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpHeaders } from '@angular/common/http';
import { TokenService } from "@app/services/token/token.service";
import { Router } from '@angular/router';

@Component({
  selector: 'nh-ridp-upload-docs',
  templateUrl: './ridp-uploadDocs.component.html',
  styleUrls: ['./ridp-uploadDocs.component.scss'],
  standalone: false
})
export class RidpUploadDocsComponent implements OnInit {
options: any[];
defaultLanguage;
translatedLang;
documents = [{ docType: null, show: true, file: null, error: false, pageId: null, groupId: null }];
displayUpload = true;
docName: string;
displayLoading: boolean;
error = true;

  constructor(private apiService: ApiService,public translateService: TranslateService,
      private token: TokenService, protected router: Router) { }

  ngOnInit(): void {
     this.defaultLanguage = this.translateService.getDefaultLang();
    this.translatedLang = this.defaultLanguage;
    this.translateService.onDefaultLangChange.subscribe((res) => {
      this.translatedLang = res.lang;
      this.options = [];
    });
  }

  getDocTypeOptions(): void {
        let url = `publ/reference-tables/retrieve?table=RIDPDOCINFO`;
            this.apiService.get(url, null, {headers: new HttpHeaders({'pageId': 'RIDPUD', 'sessionId' : this.token.getSessionId()})}).subscribe((res) => {
                this.options = res?.['columnDetails'] || [];
            });
  }

  onPrevious(){
    const from = sessionStorage.getItem('ridpUploadDocsFrom');
    if(from === 'fromVerifyDocuments'){
      sessionStorage.setItem('ridpReviewDocs', 'true')
    }
    sessionStorage.removeItem('ridpUploadDocsFrom');
    this.router.navigate(['/verify-identity/uploadDocuments']);
  }

  selectedOption(i) {
  // let currentDocTypeObj = this.documents[i].docType;
  // let currentDocType = this.translatedLang !== 'en' ? this.documents[i]['docType']['spDescription'] : this.documents[i]['docType']['enDescription']

  this.documents[i].error = !this.documents[i]?.docType;
}

  getFileDetailsMobile(fileData, i) {
    if (fileData.res !== null) {

      if(this.documents[i]){
      this.documents[i].show = false;
      this.documents[i].file = { ...fileData.fileRes.file, ...{ res: fileData.res } };
      }
      this.addDocbuttonVisibility();
    }
  }

    getFileProgress(event) {
    if (event) {
      this.displayLoading = event.displayLoading;
      this.docName = event.fileName;
      this.displayUpload = this.displayLoading ? false : true
    } else {
      this.displayLoading = false;
      this.docName = null;
      this.displayUpload = this.displayLoading ? false : true
    }
  }

    addDocbuttonVisibility() {
    this.error = this.documents.some(doc => doc.file == null || !doc.docType);
  }

documentUploaded(event){
  console.log('Document uploaded event received in RIDP Upload Docs Component:', event);  
}



}
